import { render, staticRenderFns } from "./details-section.vue?vue&type=template&id=ed68e7cc&scoped=true"
import script from "./details-section.vue?vue&type=script&lang=js"
export * from "./details-section.vue?vue&type=script&lang=js"
import style0 from "./details-section.vue?vue&type=style&index=0&id=ed68e7cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed68e7cc",
  null
  
)

export default component.exports